import { useEffect, useRef, useState } from "react";
import "./ScrollingTips.css";

const INTERVAL_MS = 7000;

function ScrollingTips({ tips }) {
  const [index, setIndex] = useState(0);
  const [paused, setPaused] = useState(false);
  const timerRef = useRef(null);

  useEffect(() => {
    if (paused) return undefined;
    timerRef.current = setInterval(() => {
      setIndex((prev) => (prev + 1) % tips.length);
    }, INTERVAL_MS);
    return () => clearInterval(timerRef.current);
  }, [tips.length, paused]);

  if (!tips.length) return null;

  return (
    <aside
      className="pa-tips"
      aria-label="Astuces"
      onMouseEnter={() => setPaused(true)}
      onMouseLeave={() => setPaused(false)}
      onFocus={() => setPaused(true)}
      onBlur={() => setPaused(false)}
    >
      <span className="pa-tips__icon" aria-hidden="true">
        <i className="bi bi-lightbulb"></i>
      </span>

      <div className="pa-tips__body">
        <p className="pa-label pa-tips__label">Astuce</p>
        <p className="pa-tips__text" aria-live="polite">
          {tips[index]}
        </p>
      </div>

      <div className="pa-tips__dots">
        {tips.map((_, i) => (
          <button
            key={i}
            type="button"
            className={`pa-tips__dot${i === index ? " is-on" : ""}`}
            onClick={() => setIndex(i)}
            aria-label={`Astuce ${i + 1} sur ${tips.length}`}
            aria-current={i === index}
          />
        ))}
      </div>
    </aside>
  );
}

export default ScrollingTips;
